import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "sonner";
import { banUnbanUser, fetchUserList } from "src/services/user.service";

interface FetchUserListPayload {
  page: number;
  limit: number;
  search?: string;
}

export const doFetchUserList = createAsyncThunk(
  "user/fetchUserList",
  async (payload: FetchUserListPayload) => {
    try {
      const response: any = await fetchUserList({
        page: payload.page,
        limit: payload.limit,
        search: payload.search,
      });
      return response;
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message || "Failed to fetch user list";
      console.log(errorMessage);
      throw errorMessage;
    }
  }
);

export const doBanUnbanUser = createAsyncThunk(
  "user/banUnbanUser",
  async (uid: string) => {
    try {
      const response: any = await banUnbanUser(uid);
      toast.success(response.message);
      return response;
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message || "Failed to ban/unban user";
      toast.error(errorMessage);
      throw errorMessage;
    }
  }
);
